import React, { useState } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button } from 'reactstrap';

import PlayButton from '../../Buttons/PlayButton/PlayButton';
import RoundedButton from '../../Buttons/RoundedButton/RoundedButton';
import Loader from '../../Common/Loader';

import { ReactComponent as TrashIcon } from '../../../assets/images/trash.svg';

import './PlaylistTrackRow.scss';

import { removeTrackFromPlaylist } from '../../../helpers/api/playlists.api';

const PlaylistTrackRow = (props) => {

    const [loading, setLoading] = useState(false);

    async function handleOnRemoveTrack() {
        setLoading(true)
        removeTrackFromPlaylist(props.playlistId, props.track._id)
            .then(result => {
                if (result.success) 
                    props.onRemoveComplete && props.onRemoveComplete();
                else console.log(result.message);
                setLoading(false)
            })
            .catch(error => {
                console.log(error);
                setLoading(false)
            });

    }

    return props.track ?
        <li className="playlist-track-row">
            <div className="title-container">
                <h6 className="mr-5 mb-0">{props.track.title}{props.user._id !== props.track.author._id && <><br /><span>{props.track.author.name}</span></>}</h6>
                <PlayButton onClick={props.onPlayClick} />
            </div>
            <div className="buttons-container">
                {loading ?
                    <Loader className="mr-2"/>
                    :
                    <Button className="remove-button ml-3 ml-lg-0 mr-0 mr-lg-3" color="link" onClick={handleOnRemoveTrack}>
                        <TrashIcon />
                    </Button>
                }
                <RoundedButton color="primary" className="d-none d-lg-block px-3" onClick={() => props.history.push('/users/' + props.track.author._id)}>VISUALIZZA Profilo</RoundedButton>
            </div>
        </li>
        : null;
}

const mapStatetoProps = (state) => {
    return { user: state.Auth.user };
};

export default withRouter(connect(mapStatetoProps, {})(PlaylistTrackRow));